import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import axios from 'axios';
import { ArrowLeft, Send, MessageSquare } from 'lucide-react';
import { toast } from 'sonner';
const API_URL = process.env.REACT_APP_BACKEND_URL;

const SupportPage = () => {
  const { user } = useAuth();
const navigate = useNavigate();
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const [sending, setSending] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!subject.trim() || !message.trim()) {
      toast.error('Please fill in the subject and message');
      return;
    }
    setSending(true);
    try {
      await axios.post(
        `${API_URL}/api/billing/support`,
        { subject: subject.trim(), message: message.trim() },
        { withCredentials: true }
      );
      toast.success('Message sent to support team');
      setSubject('');
      setMessage('');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Failed to send');
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FFFFFF]" data-testid="support-page">
      <header className="bg-white/80 backdrop-blur-xl border-b border-[#E2DDD8] sticky top-0 z-50">
        <div className="w-full max-w-[1400px] mx-auto px-6 md:px-12 py-6 flex justify-between items-center">
          <div className="flex items-center gap-4">
            <button onClick={() => navigate('/dashboard')} className="text-slate-600 hover:text-slate-900" data-testid="support-back-btn">
              <ArrowLeft className="w-5 h-5" />
            </button>
            <img src="/arpai_logo.png" alt="ARPAI" style={{height: '1.25rem'}} />
            <span className="text-xl font-bold text-[#2F2E2F] tracking-[0.15em]">GEO</span>
            <span className="hidden sm:inline text-[10px] text-slate-400 ml-2">AI brand visibility monitoring service</span>
            <span className="text-slate-300 mx-1">/</span>
            <h1 className="text-base sm:text-lg tracking-tight font-bold text-slate-500">Support</h1>
          </div>
        </div>
      </header>

      <main className="w-full max-w-[700px] mx-auto px-6 md:px-12 py-12">
        <div className="bg-white border border-[#E2DDD8] p-8" data-testid="support-form-card">
          <div className="flex items-center gap-3 mb-8">
            <MessageSquare className="w-6 h-6 text-[#1BB594]" />
            <h2 className="text-xl font-bold text-[#2F2E2F]">Contact Support</h2>
          </div>

          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label className="block text-xs font-bold uppercase tracking-[0.15em] text-slate-500 mb-2">
                Subject
              </label>
              <input
                type="text"
                value={subject}
                onChange={(e) => setSubject(e.target.value)}
                placeholder="Briefly describe the topic"
                className="w-full px-4 py-3 border border-[#E2DDD8] text-sm text-slate-900 placeholder-slate-400 focus:outline-none focus:border-[#1BB594] transition-colors"
                data-testid="support-subject-input"
              />
            </div>

            <div>
              <label className="block text-xs font-bold uppercase tracking-[0.15em] text-slate-500 mb-2">
                Message
              </label>
              <textarea
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                placeholder="Describe your issue or question in detail"
                rows={6}
                className="w-full px-4 py-3 border border-[#E2DDD8] text-sm text-slate-900 placeholder-slate-400 focus:outline-none focus:border-[#1BB594] transition-colors resize-none"
                data-testid="support-message-input"
              />
            </div>

            <button
              type="submit"
              disabled={sending || !subject.trim() || !message.trim()}
              className="w-full rounded-none font-bold tracking-widest uppercase text-xs px-4 py-4 bg-[#1BB594] text-white hover:bg-[#159A7F] transition-transform active:translate-y-1 flex items-center justify-center gap-2 disabled:opacity-50"
              data-testid="support-submit-btn"
            >
              <Send className="w-4 h-4" />
              {sending ? 'Sending...' : 'Send'}
            </button>
          </form>

          <p className="text-xs text-slate-400 mt-6 text-center">
            We will respond to your email within 24 hours
          </p>
        </div>
      </main>
    </div>
  );
};

export default SupportPage;
